import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from 'app/App';
import reportWebVitals from './reportWebVitals';
import AuthProvider from 'app/hoc/AuthProvider';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
